<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.viewDetail')"
        size="large"
        @close="closeOverSide"
        @loaded="getData">
        <div>
            <hts-card :title="$t('labels.generalInformation')">
                <div
                    class="grid gap-4"
                    :class="columnClass">
                    <hts-form-input
                        v-model="dataFormEditVehicle.licensePlate"
                        :label="$t('labels.vehicleModule.licensePlate')"
                        readonly
                        :color="props.color"
                        name="vehicleModule.licensePlate"
                        prop="vehicleModule.licensePlate" />

                    <hts-select-tracking-gps
                        v-model="dataFormEditVehicle.gpsTrackingType"
                        required
                        readonly
                        prop="gpsTrackingType"
                        name="gpsTrackingType"
                        :label="$t('labels.gpsTrackingType')" />
                </div>
            </hts-card>
        </div>

        <hts-card :title="$t('labels.driverInfo')">
            <hts-card :title="$t('labels.primaryDriver')">
                <div
                    class="grid gap-4"
                    :class="columnClass">
                    <hts-form-input
                        v-model="dataFormEditVehicle.otherCompanyDriver.fullName"
                        :label="$t('labels.fullName')"
                        :color="color"
                        readonly
                        name="fullName"
                        prop="fullName" />
                    <hts-form-phone
                        v-model="dataFormEditVehicle.otherCompanyDriver.phone"
                        :label="$t('labels.phone')"
                        prop="phone"
                        name="phone"
                        readonly
                        @updateCode="(val) => (dataFormEditVehicle.otherCompanyDriver.phone.code = val)" />
                    <hts-form-input
                        v-model="dataFormEditVehicle.otherCompanyDriver.idCardNumber"
                        :label="$t('labels.idCardNumber')"
                        :color="color"
                        readonly
                        name="idCardNumber"
                        prop="idCardNumber" />
                    <hts-form-input
                        v-model="dataFormEditVehicle.otherCompanyDriver.companyUserName"
                        :label="$t('labels.userAccount')"
                        prop="companyUserId"
                        disabled="true" />
                </div>
            </hts-card>

            <hts-card
                v-if="openAddCoDriver"
                :title="$t('labels.coDriver')">
                <div
                    class="grid gap-4"
                    :class="columnClass">
                    <hts-form-input
                        v-model="dataFormEditVehicle.otherCompanyCoDriver.fullName"
                        :label="$t('labels.fullName')"
                        :color="color"
                        readonly
                        name="fullName"
                        prop="fullName" />
                    <hts-form-phone
                        v-model="dataFormEditVehicle.otherCompanyCoDriver.phone"
                        :label="$t('labels.phone')"
                        prop="phone"
                        name="phone"
                        readonly
                        @updateCode="(val) => (dataFormEditVehicle.otherCompanyCoDriver.phone.code = val)" />
                    <hts-form-input
                        v-model="dataFormEditVehicle.otherCompanyCoDriver.idCardNumber"
                        :label="$t('labels.idCardNumber')"
                        :color="color"
                        readonly
                        name="idCardNumber"
                        prop="idCardNumber" />
                    <hts-form-input
                        v-model="dataFormEditVehicle.otherCompanyCoDriver.companyUserName"
                        :label="$t('labels.userAccount')"
                        prop="companyUserId"
                        disabled="true" />
                </div>
            </hts-card>
        </hts-card>
    </hts-drawer>
</template>

<script setup lang="ts">
import form, { CoveringContainerLevel, GoodsTypes, IVehicle } from './imports/form'
import { $api, $lodash, $urlSystem } from '#imports'
import layoutPermissions from '@/data/permissions/layout-permissions'
import { checkPermission } from '@/utils/permission-check'

const store = $store()

const route = useRoute()
const id: string = route.query.id ? String(route.query.id) : ''

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 3
  },
  disabled: {
    type: Boolean,
    default: false
  }
})

const emits = defineEmits(['close', 'refreshDataTables'])

const dataFormEditVehicle = reactive<IVehicle>({ ...form.initFormVehicle } as IVehicle)
const visible = ref(false)
const openPopupAddCategory = ref(false)
const modalConfirmDepreciationVehicle = ref(false)
const openAddCoDriver = ref<boolean>(false)

const closeOverSide = () => {
  visible.value = false
  emits('close')
}

const configCont: { [key: string]: any } = reactive({})

const openEditVehicle = async (vehicle: IVehicle) => {
  visible.value = true
  loading.value = true
  openAddCoDriver.value = false
  Object.assign(dataFormEditVehicle, { ...form.initFormVehicle })
  await getData(vehicle._id)
  if (dataFormEditVehicle.type === 1) {
    await getDataCooperator()
  }
  Object.assign(configCont, store.globalSettings.getGlobalSettings.configCont || {})
  if (dataFormEditVehicle.type === 0 || (dataFormEditVehicle.typeFleetVehicle && dataFormEditVehicle.typeFleetVehicle.includes('PARTNER'))) {
    handleInputVehicleLoad(dataFormEditVehicle.vehicleLoad)
  }
  nextTick(() => {
    loading.value = false
  })
}
defineExpose({
  openEditVehicle
})

const loading = ref(false)

const getData = async (id: string | undefined | String) => {
  const api = $urlPartner.vehicle.vehicle.getById
  await $api(api, { uriParams: { ID: id } }).then((data: any) => {
    const resData: any = data.data.value
    if (resData.success) {
      Object.assign(dataFormEditVehicle, resData.data)
      if (resData.data.otherCompanyCoDriver) {
        openAddCoDriver.value = true
      }
      defaultValueVehicle()
    }
  })
}

const defaultValueVehicle = () => {
  if ($lodash.isNil(dataFormEditVehicle.vehicleTypeDetail)) {
    dataFormEditVehicle.vehicleTypeDetail = {}
  }
  if ($lodash.isNil(dataFormEditVehicle.containerType) || !dataFormEditVehicle.containerType) {
    dataFormEditVehicle.containerType = false
    dataFormEditVehicle.goodsType = ['SOLID']
  }
  if ($lodash.isNil(dataFormEditVehicle.isGenset)) {
    dataFormEditVehicle.isGenset = false
  }

  // nếu management đã duyệt lấy giá trị đã lưu, chưa duyệt lấy giá trị bên loại xe
  dataFormEditVehicle.fuelConsumption = dataFormEditVehicle?.approvedByManagement
    ? dataFormEditVehicle?.fuelConsumption
    : dataFormEditVehicle?.vehicleTypeDetail?.oilMaterialAssumption

  dataFormEditVehicle.priceLiquidation = dataFormEditVehicle?.approvedByManagement
    ? dataFormEditVehicle?.priceLiquidation
    : dataFormEditVehicle?.vehicleTypeDetail?.liquidationValue
}

const towingCapacityList = [
  {
    value: 20,
    label: $t('labels.vehicleModule.20ft')
  },
  {
    value: 40,
    label: $t('labels.vehicleModule.40ft')
  },
  {
    value: 45,
    label: $t('labels.vehicleModule.45ft')
  }
]

const handleItemSelectListCont = computed(() => {
  const itemsSelect = [...towingCapacityList]
  towingCapacityList.forEach((item: { [key: string]: any }, index: number) => {
    if (configCont[item.value] && dataFormEditVehicle.vehicleLoad) {
      if (configCont[item.value].total > (dataFormEditVehicle.vehicleLoad || 0) || !dataFormEditVehicle.vehicleLoad) {
        const findIndex = itemsSelect.findIndex((i: any) => i.value === item.value)

        itemsSelect.splice(findIndex, 1)
      }
    }
  })
  handleUpdateContainerTypeByVehicleLoad()
  return itemsSelect
})

const coveringContainerLevel = [
  {
    value: CoveringContainerLevel.PRIVATE,
    label: $t('labels.vehicleModule.private')
  },
  {
    value: CoveringContainerLevel.OPEN,
    label: $t('labels.vehicleModule.open')
  }
]
const goodsTypes = ref([
  {
    value: GoodsTypes.LIQUID,
    label: $t('labels.liquid'),
    isChecked: false
  },
  {
    value: GoodsTypes.SOLID,
    label: $t('labels.solid'),
    isChecked: false
  },
  {
    value: GoodsTypes.GAS,
    label: $t('labels.gas'),
    isChecked: false
  }
])

const handleInputVehicleLoad = $lodash.debounce((value: number | null) => {
  const api = $urlSystem.vehicle.category['find-by-vehicle-tonnage']
  $api(api, {
    uriParams: { KEY: typeof value === 'number' ? value : typeof dataFormEditVehicle.vehicleLoad === 'number' ? dataFormEditVehicle.vehicleLoad : '' }
  }).then((data: any) => {
    const resData: any = data.data?.value
    if (resData?.success) {
      if (resData.data) {
        vehicleCategory.value = resData.data || {}
        dataFormEditVehicle.vehicleType = resData.data._id || ''
        if (!dataFormEditVehicle.approvedByManagement) {
          dataFormEditVehicle.repairingPrice = resData.data.repairingPrice || 0
          dataFormEditVehicle.priceLiquidation = resData.data.liquidationValue || 0
          dataFormEditVehicle.fuelConsumption = resData.data.oilMaterialAssumption || 0
          dataFormEditVehicle.repairingPrice = resData.data.repairingPrice || 0
        }
      } else if (!$lodash.isNil(dataFormEditVehicle.vehicleLoad)) {
        openPopupAddCategory.value = true
        vehicleCategory.value = {}
      }
    }
  })
}, 500)

watch(
  () => dataFormEditVehicle.vehicleLoad,
  (val) => {
    if (!loading.value) {
      const itemsSelect = [...towingCapacityList]
      towingCapacityList.forEach((item: { [key: string]: any }, index: number) => {
        if (configCont[item.value] && val) {
          if (configCont[item.value].total > (val || 0) || !val) {
            const findIndex = itemsSelect.findIndex((i: any) => i.value === item.value)

            itemsSelect.splice(findIndex, 1)
          }
        }
      })
      dataFormEditVehicle.towingCapacity = !dataFormEditVehicle.containerType ? itemsSelect.map((item) => item.value) : []
    }
  }
)

const handleUpdateContainerTypeByVehicleLoad = () => {
  if (Array.isArray(dataFormEditVehicle.towingCapacity)) {
    dataFormEditVehicle.towingCapacity.forEach((item: string) => {
      if (configCont[item]) {
        if (dataFormEditVehicle.vehicleLoad && configCont[item].toal >= dataFormEditVehicle.vehicleLoad) {
          dataFormEditVehicle.towingCapacity = []
          return true
        }
      }
    })
  }
}

const updateDepreciationVehicle = $lodash.debounce((depreciationVehicle?: Boolean) => {
  if (depreciationVehicle) {
    depreciationVehicleChange()
    return
  }

  if (!dataFormEditVehicle?.buyingTime || !dataFormEditVehicle?.expiredYear) {
    dataFormEditVehicle.depreciationVehicle = 1
    return
  }
  dataFormEditVehicle.depreciationVehicle = Number(dataFormEditVehicle.expiredYear) - Number(dataFormEditVehicle.buyingTime)
  if (dataFormEditVehicle.depreciationVehicle < 1) {
    dataFormEditVehicle.depreciationVehicle = 1
  }
}, 500)

const handleOpenPopupTollStation = () => {
  if (addTollStation.value) {
    addTollStation.value.open()
  }
}
const handleAddTollStation = (data: any, value: string, index: number) => {
  if (!(typeof index === 'number')) {
    data.newTollStation = true
    dataFormEditVehicle.tollStation.push(data)
  }
  if (typeof index === 'number') {
    Object.assign(dataFormEditVehicle.tollStation[index], { ...data })
  }
}
const handleRemove = (index: number) => {
  dataFormEditVehicle.tollStation.splice(index, 1)
}

const handleSubmitFormEditVehicle = async () => {
  if (dataFormEditVehicle.type === 0 && !Object.keys(vehicleCategory.value).length) {
    openPopupAddCategory.value = true
    return
  }
  const api = $urlPartner.vehicle.vehicle.edit

  if (!dataFormEditVehicle.containerType) {
    dataFormEditVehicle.goodsType = []
    dataFormEditVehicle.coveringContainerLevel = ''
  }

  const data: any = await $api(api, {
    uriParams: { ID: dataFormEditVehicle._id },
    body: { ...dataFormEditVehicle }
  })
  const resData: any = data?.data?.value
  if (resData.success) {
    process.client && $toast().success(resData.data)
    emits('refreshDataTables')
    emits('close')
    visible.value = false
  }
}

const vehicleCategory = ref({})

const columnClass = computed(() => {
  switch (props.column) {
  case 1:
    return 'grid-cols-1'
  case 2:
    return 'grid-cols-2'
  case 3:
    return 'grid-cols-3'
  case 4:
    return 'grid-cols-4'
  case 5:
    return 'grid-cols-5'
  case 6:
    return 'grid-cols-6'
  case 7:
    return 'grid-cols-7'
  case 8:
    return 'grid-cols-8'
  case 9:
    return 'grid-cols-9'
  case 10:
    return 'grid-cols-10'
  case 11:
    return 'grid-cols-11'
  case 12:
    return 'grid-cols-12'
  }

  return 'grid-cols-1'
})

const addTollStation = ref()

const depreciationVehicleChange = () => {
  if (!checkPermission(layoutPermissions.vehicle_administration)) {
    return
  }
  const expiredYear = Number(dataFormEditVehicle.expiredYear) || undefined
  const buyingTime = Number(dataFormEditVehicle.buyingTime) || undefined
  const depreciationVehicle = Number(dataFormEditVehicle.depreciationVehicle) || undefined

  if (typeof expiredYear !== 'number' || typeof buyingTime !== 'number' || typeof depreciationVehicle !== 'number') {
    return
  }
  if (depreciationVehicle > 0 && depreciationVehicle < expiredYear - buyingTime) {
    modalConfirmDepreciationVehicle.value = true
  }
}

const getDataCooperator = async () => {
  const api = $urlPartner.partner['get-detail']
  await $api(api, { uriParams: { ID: dataFormEditVehicle.fleetVehicle } })
    .then((data: any) => {
      const resData: any = data.data.value
      if (resData.success) {
        dataFormEditVehicle.typeFleetVehicle = resData.data.type
      }
    })
    .catch(() => {
      visible.value = false
    })
}
</script>
